// @core/api/endpoints/search/get_index_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetIndexStatsResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Get index statistics
 * Returns statistics for a search index including document count, index size, and last reindex time.
 */
export async function GetIndexStats(
  index_id: string,
  options?: RequestOptions
): Promise<GetIndexStatsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/search/indexes/:index_id/stats`;
  requestPath = requestPath.replace(':index_id', encodeURIComponent(index_id));
  const requestOptions = options;
  return client.get<GetIndexStatsResponse>(requestPath, { ...requestOptions });
}
